import React from 'react';
import './styles/Control.css'
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../Firebase/firebase';
import Loading from '../components/Loading'
import PleaseSignIn from '../components/PleaseSignIn'
import NotAuthorized from '../components/NotAuthorized'
import ControllerNavBar from '../navigation/ControllerNavBar'
import RaceController from './RaceController'
import Admin from './Admin'
import { Route, Routes, Navigate } from "react-router-dom";

export default class ControlClass extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            authorized: false,
            signingIn: true,
            authError: null,
        };
        this.unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user) {
                this.setState({ authorized: false, user: null, signingIn: false, authError: null });
                return;
            }
            if (!this.props.team) {
                this.setState({ authorized: false, user, signingIn: false, authError: null });
                return;
            }
            getDoc(doc(db, 'teamroles', this.props.team)).then(snap => {
                const data = snap.data();
                const authorized = !!(data && data.roles && data.roles[user.uid] === "controller");
                this.setState({ authorized, user, signingIn: false, authError: null });
            }).catch(error => {
                console.log(`Failed to check team roles: ${error}`);
                this.setState({ authorized: false, user, signingIn: false, authError: error.message || String(error) });
            });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
    }

    render() {
        if (!this.state.user) {
            return this.state.signingIn
                ? <Loading />
                : <PleaseSignIn signIn={this.props.signIn} />;
        }
        if (!this.state.authorized) {
            return (
                <NotAuthorized
                    user={this.state.user}
                    signIn={this.props.signIn}
                    signOut={this.props.signOut}
                    authError={this.state.authError}
                />
            );
        }
        return (
            <div>
                <ControllerNavBar {...this.props} user={this.state.user} />
                <Routes>
                    <Route path="control" element={<RaceController {...this.props} {...this.state} />} />
                    <Route path="admin" element={<Admin {...this.props} {...this.state} />} />
                    <Route path="" element={<Navigate to="control" replace />} />
                </Routes>
            </div>
        );
    }
}
